import { useEffect } from "react";
import { App } from "@capacitor/app";
import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import HomeTopCard from "../../../components/HomeComponents/HomeTopCard";
import HomeCategoryCard from "../../../components/HomeComponents/HomeCategoryCard";
import SearchBar from "../../../components/BookComponents/BasicSearch";
import CategoryBrowser from "../../../components/BookComponents/CategoryBrowser";
import HomeTodayForYouCard from "../../../components/HomeComponents/HomeTodayForYouCard";
import BookDiscoveryPage from "../../../components/HomeComponents/BookDiscovery";
import HomeTagsSlider from "../../../components/HomeComponents/HomeTagCard";
import HomeBookCollections from "../../../components/HomeComponents/HomeCollections";

export const UserHomePage = () => {
  useEffect(() => {
    const backHandler = () => {
      App.exitApp();
      return true;
    };
    const backButtonListener = App.addListener("backButton", backHandler);
    return () => {
      backButtonListener.remove();
    };
  }, []);

  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar displayType="logo" showNotification showProfileBtn></TopBar>
        <SearchBar></SearchBar>
        <HomeTopCard></HomeTopCard>
        {/* <HomeTodayForYouCard></HomeTodayForYouCard> */}
        <BookDiscoveryPage></BookDiscoveryPage>
        <HomeCategoryCard></HomeCategoryCard>
        <HomeBookCollections></HomeBookCollections>
        <HomeTagsSlider></HomeTagsSlider>
        <CategoryBrowser></CategoryBrowser>
        <Tabbar menuType={"users"}></Tabbar>
      </div>
    </>
  );
};

export default UserHomePage;
